// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAVFqafQQwTv8sJF9lW7JLqdaRtTPZ-x48",
  authDomain: "amazingticket.firebaseapp.com",
  projectId: "amazingticket",
  storageBucket: "amazingticket.appspot.com",
  messagingSenderId: "882071102457",
  appId: "1:882071102457:web:28f28d329e02b682c6d328",
  measurementId: "G-4WQL2Z4TD6"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);

export { firebaseApp, analytics }